<kendo-expansionpanel [title]="'Filters'"
                      [subtitle]="''"
                      [disabled]="false"
                      [expanded]="true">
    <div class="row">
        <div class="col-sm-10">
            <div class="row">
                <div class="col-sm-2">
                    <div class="form-group">
                        <label><strong>Customer Name</strong></label>
                        <input class="form-control" type="text" [(ngModel)]="nameFilter" />
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group">
                        <label><strong>Customer Code</strong></label>
                        <input class="form-control" type="text" [(ngModel)]="codeFilter" />
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group">
                        <label><strong>City</strong></label>
                        <input class="form-control" type="text" [(ngModel)]="cityFilter" />
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group">
                        <label><strong>State</strong></label>
                        <input class="form-control" type="text" [(ngModel)]="stateFilter" />
                    </div>
                </div>
                <div class="col-xl-2 col-sm-3 col-xs-4">
                    <div class="form-group">
                        <label><strong>Last Action</strong></label><br />
                        <kendo-datepicker [(ngModel)]="beginActionDate" (valueChange)="dateFilterChange($event)"></kendo-datepicker>
                        <kendo-datepicker [(ngModel)]="endActionDate" (valueChange)="dateFilterChange($event)"></kendo-datepicker>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group">
                        <label><strong>Days in Status</strong></label>
                        <input class="form-control" type="number" [(ngModel)]="daysFilter" />
                    </div>
                </div>
                <div class="col-xl-2 col-sm-3 col-xs-4">
                    <div class="form-group">
                        <label><strong>Initiative</strong></label><br />
                        <initiatives-dropdown (selectedInitiativeChanged)="initiativeFilter = $event?.title"></initiatives-dropdown>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group">
                        <label><strong>Sales Rep</strong></label>
                        <input class="form-control" type="text" [(ngModel)]="salesRepFilter" />
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group">
                        <label><strong>Account Rep</strong></label>
                        <input class="form-control" type="text" [(ngModel)]="accountRepFilter" />
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-2">
            <div class="row">
                <div class="col-sm-12">
                    <button class="btn btn-primary" (click)="filterCustomers()">Apply Filters</button>
                </div>
                <div class="col-sm-12">
                    <button class="btn btn-secondary" (click)="clearFilters()">Clear Filters</button>
                </div>
            </div>
        </div>
    </div>
</kendo-expansionpanel>

<div class="row">
    <div class="col" *ngFor="let customerStatus of customerStatusList">
        <h3 class="text-center">{{customerStatus.description}}: ({{getCustomerCount(customerStatus.customerStatusId)}})</h3>
        <h5 class="text-center">{{getCustomerFreightSpend(customerStatus.customerStatusId) | currency:'USD'}}</h5>
        <div *ngFor="let customer of getCustomers(customerStatus.customerStatusId)">
            <div class="crm-card" (click)="openCustomerStatusDialog(customer.customerID, customer.customerStatus)">
                <ul>
                    <li>
                        <h5><a href="/#/customer-detail/{{customer.customerCode}}" target="_blank">{{customer.customerName}}</a></h5>
                        <h5><a href="/#/customer-detail/{{customer.customerCode}}" target="_blank">{{customer.customerCode}}</a></h5>
                    </li>
                    <li>
                        <label>Freight Spend:</label> {{customer.freightSpend | currency:'USD'}}
                    </li>
                    <li>
                        <label>Last Action:</label> {{customer.maxActionDate | date: 'M/dd/yyyy HH:mm'}}
                    </li>
                    <li>
                        <label>Last Checklist:</label> {{customer.maxChecklistDate | date: 'M/dd/yyyy HH:mm'}}
                    </li>
                    <li>
                        <label>Sales Rep:</label> {{customer.salesRepName}}
                    </li>
                    <li>
                        <label>Account Rep:</label> {{customer.accountRepName}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="col-lg-3" *ngIf="false">
        <h3 class="text-center">Prospect ({{prospects.length}})</h3>
        <h5 class="text-center">{{prospectFreightSpend | currency:'USD'}}</h5>
        <div *ngFor="let customer of prospects">
            <div class="crm-card" (click)="openCustomerStatusDialog(customer.customerID, customer.customerStatus)">
                <ul>
                    <li>
                        <h5><a href="/#/customer-detail/{{customer.customerCode}}" target="_blank">{{customer.customerName}}</a></h5>
                        <h5><a href="/#/customer-detail/{{customer.customerCode}}" target="_blank">{{customer.customerCode}}</a></h5>
                    </li>
                    <li>
                        <label>Freight Spend:</label> {{customer.freightSpend | currency:'USD'}}
                    </li>
                    <li>
                        <label>Last Action:</label> {{customer.maxActionDate | date: 'M/dd/yyyy HH:mm'}}
                    </li>
                    <li>
                        <label>Last Checklist:</label> {{customer.maxChecklistDate | date: 'M/dd/yyyy HH:mm'}}
                    </li>
                    <li>
                        <label>Sales Rep:</label> {{customer.salesRepName}}
                    </li>
                    <li>
                        <label>Account Rep:</label> {{customer.accountRepName}}
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="col-lg-3" *ngIf="false">
        <h3 class="text-center">Rapport Building ({{rapportBuildings.length}})</h3>
        <h5 class="text-center">{{rapportBuildingFreightSpend | currency:'USD'}}</h5>
        <div *ngFor="let customer of rapportBuildings">
            <div class="crm-card" (click)="openCustomerStatusDialog(customer.customerID, customer.customerStatus)" style="cursor: pointer;">
                <ul>
                    <li>
                        <h5><a href="/#/customer-detail/{{customer.customerCode}}" target="_blank">{{customer.customerName}}</a></h5>
                        <h5><a href="/#/customer-detail/{{customer.customerCode}}" target="_blank">{{customer.customerCode}}</a></h5>
                    </li>
                    <li>
                        <label>Freight Spend:</label> {{customer.freightSpend | currency:'USD'}}
                    </li>
                    <li>
                        <label>Last Action:</label> {{customer.maxActionDate | date: 'M/dd/yyyy HH:mm'}}
                    </li>
                    <li>
                        <label>Last Checklist:</label> {{customer.maxChecklistDate | date: 'M/dd/yyyy HH:mm'}}
                    </li>
                    <li>
                        <label>Sales Rep:</label> {{customer.salesRepName}}
                    </li>
                    <li>
                        <label>Account Rep:</label> {{customer.accountRepName}}
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="col-lg-3" *ngIf="false">
        <h3 class="text-center">Drawing Pain ({{drawingPains.length}})</h3>
        <h5 class="text-center">{{drawingPainFreightSpend | currency:'USD'}}</h5>
        <div *ngFor="let customer of drawingPains">
            <div class="crm-card" (click)="openCustomerStatusDialog(customer.customerID, customer.customerStatus)" style="cursor: pointer;">
                <ul>
                    <li>
                        <h5><a href="/#/customer-detail/{{customer.customerCode}}" target="_blank">{{customer.customerName}}</a></h5>
                        <h5><a href="/#/customer-detail/{{customer.customerCode}}" target="_blank">{{customer.customerCode}}</a></h5>
                    </li>
                    <li>
                        <label>Freight Spend:</label> {{customer.freightSpend | currency:'USD'}}
                    </li>
                    <li>
                        <label>Last Action:</label> {{customer.maxActionDate | date: 'M/dd/yyyy HH:mm'}}
                    </li>
                    <li>
                        <label>Last Checklist:</label> {{customer.maxChecklistDate | date: 'M/dd/yyyy HH:mm'}}
                    </li>
                    <li>
                        <label>Sales Rep:</label> {{customer.salesRepName}}
                    </li>
                    <li>
                        <label>Account Rep:</label> {{customer.accountRepName}}
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="col-lg-3" *ngIf="false">
        <h3 class="text-center">Qualified Prospect ({{qualifiedProspects.length}})</h3>
        <h5 class="text-center">{{qualifiedProspectFreightSpend | currency:'USD'}}</h5>
        <div *ngFor="let customer of qualifiedProspects">
            <div class="crm-card" (click)="openCustomerStatusDialog(customer.customerID, customer.customerStatus)" style="cursor: pointer;">
                <ul>
                    <li>
                        <h5><a href="/#/customer-detail/{{customer.customerCode}}" target="_blank">{{customer.customerName}}</a></h5>
                        <h5><a href="/#/customer-detail/{{customer.customerCode}}" target="_blank">{{customer.customerCode}}</a></h5>
                    </li>
                    <li>
                        <label>Freight Spend:</label> {{customer.freightSpend | currency:'USD'}}
                    </li>
                    <li>
                        <label>Last Action:</label> {{customer.maxActionDate | date: 'M/dd/yyyy HH:mm'}}
                    </li>
                    <li>
                        <label>Last Checklist:</label> {{getLastChecklist(customer)}} {{customer.maxChecklistDate | date: 'M/dd/yyyy HH:mm'}}
                    </li>
                    <li>
                        <label>Sales Rep:</label> {{customer.salesRepName}}
                    </li>
                    <li>
                        <label>Account Rep:</label> {{customer.accountRepName}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
